import { Injectable } from '@angular/core';
import { CommonService } from '../../shared/services/common.service';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { PartGroup } from '../partgroup/partgroup.model';

@Injectable()
export class SearchResolver implements Resolve<PartGroup[]> {
    constructor(private _commonService: CommonService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this._commonService.getSearchResultsByDescription(route.paramMap.get('text'));
    }
}



// WEBPACK FOOTER //
// ./src/opc/opc-app/searchresult/searchresolver.ts